// ==============================|| OVERRIDES - TYPOGRAPHY ||============================== //

export default function Typography(theme) {
  return {
    MuiTypography: {
      variants: [
        {
          props: { variant: 'landing-header-text' },
          style: {
            color: '#fff',
            fontSize: '1rem',
            fontWeight: 400
          }
        },
        {
          props: { variant: 'landing-title' },
          style: {
            fontWeight: 700,
            fontSize: 'clamp(2rem, 5vw, 3.5rem)',
            lineHeight: 1.1,
            textAlign: 'center',
            color: '#fff',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            textShadow: '0 2px 10px rgba(0, 0, 0, 0.25)'
          }
        },
        {
          props: { variant: 'landing-caption' },
          style: {
            fontSize: '0.85rem',
            color: '#666',
            textAlign: 'center',
            marginTop: '8px'
          }
        },
        {
          props: { variant: 'landing-revjet' },
          style: {
            fontSize: '1.25rem',
            fontWeight: 700,
            color: '#1976D2',
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline'
            }
          }
        }
      ],
      styleOverrides: {
        gutterBottom: {
          marginBottom: 12
        }
      }
    }
  };
}
